import { log } from "./log.js";

const local = window.localStorage;
const session = window.sessionStorage;

// TODO: update each year
const keyPrefix = "itp2023";

// support multiple storage backends
function storageBackend(storage) {
  if (typeof storage !== "string") {
    return local;
  } else {
    switch (storage) {
      case "local":
        return local;
      default:
        return session;
    }
  }
}

export function set(key, value, storage) {
  storage = storageBackend(storage);
  key = keyPrefix + key;

  try {
    log("Storing " + key + " = " + value);
    storage.setItem(key, "" + value);
  } catch (err) {
    log("Storing error: " + err);
    return false;
  }

  return true;
}

export function get(key, storage) {
  storage = storageBackend(storage);
  key = keyPrefix + key;

  const item = storage.getItem(key);

  log("Get from storage " + key + ":" + item);

  return item;
}

export function remove(key, storage) {
  storage = storageBackend(storage);
  key = keyPrefix + key;

  log("Removing from storage: " + key);

  return storage.removeItem(key);
}

export default {};
